<template>
  <BaseVeeForm :action="submit" ensure-error-keys-camel-case v-slot="formProps" class="space-y-8">
    <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl max-w-lg w-full">
        <div class="flex flex-col">
          <div class="flex-none px-4 py-4 sm:px-6 border-b border-gray-200">
            <div class="flex justify-between items-center">
              <div class="flex-1">Edit Client</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 px-4 pt-4 pb-4 sm:pb-6 sm:px-6">
            <div class="space-y-8">
              <div class="space-y-4">
                <ValidationProvider name="job position" slim vid="jobPosition">
                  <template #default="{ errors }">
                    <BaseFormGroup>
                      <BaseFormLabel> Job position </BaseFormLabel>
                      <BaseFormInput
                        v-model="formData.jobPosition"
                        :disabled="formProps.isPending"
                      />
                      <BaseFormInlineMessage v-if="errors.length" danger>
                        {{ errors[0] }}
                      </BaseFormInlineMessage>
                    </BaseFormGroup>
                  </template>
                </ValidationProvider>
              </div>
              <div class="flex space-x-2">
                <BaseButton primary :disabled="formProps.invalid || formProps.isPending">
                  Save
                </BaseButton>
                <BaseButton
                  type="button"
                  primary
                  outline
                  :disabled="formProps.isPending"
                  @click="close"
                >
                  Cancel
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'AccountEditModal',
  props: {
    action: {
      type: Function,
      required: true,
    },
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        jobPosition: this.account.jobPosition,
      },
    };
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
    async submit() {
      try {
        await this.action(this.formData);

        this.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
